module.exports = __webpack_public_path__ + "static/Nutrition-a9c5a516f513d8628c73dbdf961d75d8.png";